import { Component, OnInit } from '@angular/core';
import { SingleSourceSingleValueWidget } from "../../base/SingleSourceSingleValueWidget";

@Component({
  selector: 'app-dashboard-widget',
  templateUrl: './dashboard-widget.component.html',
  styleUrls: ['./dashboard-widget.component.css']
})
export class DashboardWidgetComponent extends SingleSourceSingleValueWidget implements OnInit {

  w: any;
  url: any;

  override ngOnInit() {
    this.w = <any>this.widget;
  }
}
